import { axios } from '@/utils/request'

/**
 * 查询科室管理/备案
 *
 * @author liwei
 * @date 2022-05-11 16:41:02
 */
export function baDepartmentPage (parameter) {
  return axios({
    url: '/baDepartment/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 科室管理/备案列表
 *
 * @author liwei
 * @date 2022-05-11 16:41:02
 */
export function baDepartmentList (parameter) {
  return axios({
    url: '/baDepartment/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加科室管理/备案
 *
 * @author liwei
 * @date 2022-05-11 16:41:02
 */
export function baDepartmentAdd (parameter) {
  return axios({
    url: '/baDepartment/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑科室管理/备案
 *
 * @author liwei
 * @date 2022-05-11 16:41:02
 */
export function baDepartmentEdit (parameter) {
  return axios({
    url: '/baDepartment/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除科室管理/备案
 *
 * @author liwei
 * @date 2022-05-11 16:41:02
 */
export function baDepartmentDelete (parameter) {
  return axios({
    url: '/baDepartment/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出科室管理/备案
 *
 * @author liwei
 * @date 2022-05-11 16:41:02
 */
export function baDepartmentExport (parameter) {
  return axios({
    url: '/baDepartment/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
